import { Template } from './singed-in'

export default Template
